import { IvSegment, IvTrack } from '../types'
import { getTimelineBySceneUuid } from '../timeline'
import { getSceneSegments } from '.'

type UseRemovedSegmentsFn = () => void

export function useRemovedSegments(
  sceneUuid: IvSegment['sceneUuid'],
  fn: UseRemovedSegmentsFn,
  options?: {
    fromTracks?: IvTrack[]
  },
): IvSegment['id'][] {
  const { fromTracks } = options ?? {}
  const oldTracks = fromTracks ?? getTimelineBySceneUuid(sceneUuid)
  const oldSegments = getSceneSegments(sceneUuid, oldTracks)
  fn()
  const newTracks = fromTracks ?? getTimelineBySceneUuid(sceneUuid)
  const newSegments = getSceneSegments(sceneUuid, newTracks)

  return oldSegments
    .filter((oldSegment) => !newSegments.some((s) => s.id === oldSegment.id))
    .map((s) => s.id)
}
